

import React, { useState, useEffect } from 'react'
import { useLocation, withRouter } from 'react-router-dom';
import PlanService from "../../../services/PlanService";
const Preview = () => {
    const [preview, setPreview] = useState([]);
    const location = useLocation()

    useEffect(() => {
        previewPlan()
    }, [])

    const previewPlan = () => {
        const previewData = JSON.parse(localStorage.getItem('previewData'));
        if (previewData) {
            PlanService.previewPlan(previewData).then(response => {
                setPreview(response.data)
              })
        }
    }
    return (
        <div className="flex justify-center items-center w-full h-full min-w-screen min-h-screen">
            <div dangerouslySetInnerHTML={{ __html: preview }}></div>
        </div>
    )
}

export default withRouter(Preview)
